import { useState } from 'react';

const FALLBACK_IMAGES = {
  hack: 'https://images.unsplash.com/photo-1556228720-195a672e8a03?w=900&q=80',
  product: 'https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=900&q=80',
  tip: 'https://images.unsplash.com/photo-1571902943202-507ec2618e8f?w=900&q=80',
};

export const SmartImage = ({ src, alt, fallbackKind = 'hack', className = '', ...rest }) => {
  const [error, setError] = useState(false);
  const finalSrc = error || !src ? FALLBACK_IMAGES[fallbackKind] : src;
  return (
    <img
      src={finalSrc}
      alt={alt}
      onError={() => setError(true)}
      loading="lazy"
      className={className}
      {...rest}
    />
  );
};

export default SmartImage;
